var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg40Hc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 220.378,
    height: 160.366,
    viewBox: "0 0 220.378 160.366",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1113",
    "data-name": "Rectangle 1113",
    width: 57.642,
    height: 25.373,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fcl_hc40",
    transform: "translate(0.702 1.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M204.668,99.457l-1.3-1.834,49.5-17.683,49.51,17.683L283.946,123.8",
    transform: "translate(-90.492 -39.704)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M222.863,89.534,214.42,78.279V67.63H294.3V78.279l-8.426,11.255",
    transform: "translate(-91.982 -38.044)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1111",
    "data-name": "Rectangle 1111",
    width: 42.104,
    height: 14.006,
    transform: "translate(141.332 15.58)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1112",
    "data-name": "Rectangle 1112",
    width: 12.397,
    height: 15.58,
    transform: "translate(155.355)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M87.78,108.383l99.3-5.943,50.089,2.812",
    transform: "translate(-74.899 -42.739)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M213.435,211.146a1,1,0,0,1,0-.493l.657-4.594a.407.407,0,0,1,.277-.372.372.372,0,0,1,.476.251.467.467,0,0,1,0,.2l-.623,4.395h0l1.644-.493a.052.052,0,0,0,0-.069l-.389-1.3a.4.4,0,0,1,.761-.234l.389,1.3a.052.052,0,0,0,.069,0l.363-.112a.365.365,0,0,1,.208.7l-.363.112a.052.052,0,0,0,0,.069l.216.709a.4.4,0,0,1-.761.234l-.216-.709a.052.052,0,0,0-.069,0l-2.137.64a.381.381,0,0,1-.5-.234Z",
    transform: "translate(-91.845 -56.665)",
    fill: "#167d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M218.756,207.713a7.423,7.423,0,0,1-.476-2.068,1.895,1.895,0,0,1,3.391-1.021,15.763,15.763,0,0,1,1.22,4.049,1.886,1.886,0,0,1-3.391,1.021,7.44,7.44,0,0,1-.744-1.981Zm2.6,1.938a.96.96,0,0,0,.753-.865,18.166,18.166,0,0,0-1.125-3.737,1.064,1.064,0,0,0-1.877.562,18.167,18.167,0,0,0,1.125,3.737.96.96,0,0,0,1.107.3Z",
    transform: "translate(-92.503 -56.424)",
    fill: "#167d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M228.336,203.492a.326.326,0,0,1,.19.623l-.649.2a.052.052,0,0,0,0,.069l1,3.331a.4.4,0,0,1-.761.234l-1-3.331a.052.052,0,0,0-.069,0l-.242.078a.326.326,0,0,1-.19-.623l.242-.078a.052.052,0,0,0,0-.069l-.112-.381c-.311-1.047,0-1.523.926-1.8h.061a.363.363,0,0,1,.51.234.355.355,0,0,1-.268.467c-.562.173-.64.311-.484.865l.13.433a.052.052,0,0,0,.069,0Z",
    transform: "translate(-93.596 -56.13)",
    fill: "#167d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M232.711,207.137c-.865.268-1.332,0-1.609-.917l-.735-2.448a.052.052,0,0,0-.069,0l-.242.078a.324.324,0,0,1-.182-.623l.242-.078a.052.052,0,0,0,0-.069l-.285-.96a.4.4,0,0,1,.77-.234l.285.96a.052.052,0,0,0,.069,0l.571-.173a.326.326,0,0,1,.19.623l-.571.173a.052.052,0,0,0,0,.069l.727,2.422c.138.467.3.562.761.424a.355.355,0,0,1,.484.242c.061.208,0,.4-.3.476Z",
    transform: "translate(-94.035 -56.116)",
    fill: "#167d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M161.521,209.78l-3.261,3.512,4.161,2.362",
    transform: "translate(-84.406 -57.219)",
    fill: "none",
    stroke: "#167d86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M264.75,186.534l3.261-3.5-4.161-2.37",
    transform: "translate(-98.65 -53.291)",
    fill: "none",
    stroke: "#167d86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_221",
    "data-name": "Line 221",
    y1: 26.334,
    x2: 95.507,
    transform: "translate(73.854 129.739)",
    fill: "none",
    stroke: "#167d86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_222",
    "data-name": "Line 222",
    x2: 6.203,
    transform: "translate(161.558 7.786)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M299.04,108.781,255.845,92.95l-28.185,9.43",
    transform: "translate(-93.768 -41.459)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M202,130.64c5.069,0,5.069,3.339,10.139,3.339s5.069-3.339,10.139-3.339,5.069,3.339,10.139,3.339,5.069-3.339,10.139-3.339,5.069,3.339,10.139,3.339,5.069-3.339,10.139-3.339,5.069,3.339,10.139,3.339,5.069-3.339,10.139-3.339,5.069,3.339,10.148,3.339,5.069-3.339,10.148-3.339",
    transform: "translate(-90.307 -46.543)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_223",
    "data-name": "Line 223",
    y2: 47.857,
    transform: "translate(162.38 40.236)",
    fill: "none",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_224",
    "data-name": "Line 224",
    y1: 3.547,
    transform: "translate(149.057 21.143)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_225",
    "data-name": "Line 225",
    y1: 3.547,
    transform: "translate(157.518 21.143)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_226",
    "data-name": "Line 226",
    y1: 3.547,
    transform: "translate(165.987 21.143)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_227",
    "data-name": "Line 227",
    y1: 3.547,
    transform: "translate(174.448 21.143)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9166",
    "data-name": "Group 9166",
    transform: "translate(162.034 86.796)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M202,141.64c5.069,0,5.069,3.339,10.139,3.339s5.069-3.339,10.139-3.339,5.069,3.339,10.139,3.339,5.069-3.339,10.139-3.339,5.069,3.339,10.139,3.339,5.069-3.339,10.139-3.339,5.069,3.339,10.139,3.339,5.069-3.339,10.139-3.339,5.069,3.339,10.148,3.339,5.069-3.339,10.148-3.339",
    transform: "translate(-252.34 -134.823)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    d: "M77.83,112.273l-2.474-3.123-2.466,3.123",
    transform: "translate(-72.89 -43.645)",
    fill: "none",
    stroke: "#167d86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M72.89,180.5l2.466,3.132L77.83,180.5",
    transform: "translate(-72.89 -53.27)",
    fill: "none",
    stroke: "#167d86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_228",
    "data-name": "Line 228",
    y2: 64.156,
    transform: "translate(2.466 66.206)",
    fill: "none",
    stroke: "#167d86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M151.88,189.192V110.606l4.646-.234-.017,1.2,85.861-6.324v-1.194l3.443-.208-.009,60.834Z",
    transform: "translate(-83.546 -42.93)",
    fill: "#f0f3f5",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M152.85,118.241l4.248-.311v66.993l-4.248,1.038",
    transform: "translate(-83.676 -44.829)",
    fill: "#f0f3f5",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M178.066,180.135v-64.1l-4.066.355v64.7Z",
    transform: "translate(-86.53 -44.574)",
    fill: "#f0f3f5",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M167.6,182.609V117.06l-4.066.346v66.163Z",
    transform: "translate(-85.117 -44.712)",
    fill: "#f0f3f5",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M183.95,178.911l3.85-.934V115.17l-3.85.346Z",
    transform: "translate(-87.872 -44.457)",
    fill: "#f0f3f5",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M194.38,176.6l3.642-.882V114.29l-3.642.32Z",
    transform: "translate(-89.279 -44.338)",
    fill: "#f0f3f5",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M204.81,174.3l3.443-.83V113.4l-3.443.3Z",
    transform: "translate(-90.686 -44.218)",
    fill: "#f0f3f5",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M215.01,172.049l3.218-.787V112.53l-3.218.277Z",
    transform: "translate(-92.062 -44.1)",
    fill: "#f0f3f5",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M224.95,169.867l3.019-.753V111.68l-3.019.26Z",
    transform: "translate(-93.403 -43.986)",
    fill: "#f0f3f5",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M234.42,167.763l2.8-.675V110.96l-2.8.242Z",
    transform: "translate(-94.68 -43.889)",
    fill: "#f0f3f5",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M243.4,165.794l2.6-.657V110.28l-2.6.225Z",
    transform: "translate(-95.892 -43.797)",
    fill: "#f0f3f5",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M252.13,163.871l2.388-.58V109.62l-2.388.208Z",
    transform: "translate(-97.069 -43.708)",
    fill: "#f0f3f5",
    stroke: "#131924",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_244",
    "data-name": "Ellipse 244",
    cx: 0.381,
    cy: 0.926,
    rx: 0.381,
    ry: 0.926,
    transform: "translate(70.298 69.667)",
    fill: "#131924"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M87.78,173.464l55.514,16.411v-78.56L87.78,109.23Z",
    transform: "translate(-74.899 -43.655)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M91.02,114.42v55.955l49.51,13.7v-66.6Z",
    transform: "translate(-75.336 -44.355)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_229",
    "data-name": "Line 229",
    x2: 0.078,
    y2: 60.687,
    transform: "translate(40.893 72.357)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_230",
    "data-name": "Line 230",
    y2: 68.473,
    transform: "translate(56.136 70.488)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_231",
    "data-name": "Line 231",
    y2: 65.877,
    transform: "translate(44.769 69.987)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_232",
    "data-name": "Line 232",
    y2: 63.646,
    transform: "translate(36.75 69.9)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_233",
    "data-name": "Line 233",
    y2: 60.86,
    transform: "translate(25.642 69.442)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M90.4,111.955c0,.424-.164.744-.363.718s-.363-.407-.363-.865.164-.744.363-.718S90.4,111.531,90.4,111.955Z",
    transform: "translate(-75.154 -43.906)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M149.412,114.831c0,.554-.216.969-.476.926s-.476-.528-.476-1.081.216-.969.476-.926S149.412,114.3,149.412,114.831Z",
    transform: "translate(-83.084 -44.265)",
    fill: "#131924"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M94.57,121.93v4.144l17.994,1.756v-4.239Z",
    transform: "translate(-75.815 -45.369)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M125.03,124.74v4.239l17.285,1.6v-4.265Z",
    transform: "translate(-79.924 -45.748)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M125.03,142.46v3.9l17.216,2.457v-3.876Z",
    transform: "translate(-79.924 -48.138)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M125.03,157.89v4.144l17.216,2.924v-4.343Z",
    transform: "translate(-79.924 -50.219)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M125.03,175.35v3.616l16.991,3.789v-3.607Z",
    transform: "translate(-79.924 -52.575)",
    fill: "none",
    stroke: "#131924",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M94.57,138.11v3.91l17.994,2.569v-3.91Z",
    transform: "translate(-75.815 -47.551)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M94.57,152.4v3.616l17.994,3.3v-3.642Z",
    transform: "translate(-75.815 -49.479)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    d: "M94.57,168.56v3.6l17.994,4.031v-3.642Z",
    transform: "translate(-75.815 -51.659)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg40Hc);
export default __webpack_public_path__ + "static/media/40hc.7aed244da83b9380a013a094da6d9c4e.svg";
export { ForwardRef as ReactComponent };